import curry from "lodash/curry";

import { initialState } from "@app/statefx/schema";

import type { TStringInterval } from "@app/types/insider";

export type AppState = typeof initialState;

type TWUPparade = {
  apiUrl:
    | string
    | ((issuers: string[], slices: TStringInterval[], ama: number) => void);
  index: number | null;
};

function builder(
  aUrl: string,
  issues: string[],
  slices: TStringInterval[],
  ama: number
): string[] {
  const result = [];
  for (const interval of slices) {
    for (const emitent of issues) {
      const allParams = new URLSearchParams({
        startdate: interval.start,
        start: interval.start,
        enddate: interval.end,
        end: interval.end,
        ama: `${ama}`,
        amaid: `${ama}`,
        emitent: emitent,
      });
      result.push(`${aUrl}?${allParams.toString()}`);
    }
  }
  return result;
}

function builderAnyOneIssuer(
  aUrl: string,
  issues: string[],
  slices: TStringInterval[],
  ama: number
): string[] {
  const result = [];
  for (const interval of slices) {
    const allParams = new URLSearchParams({
      startdate: interval.start,
      start: interval.start,
      enddate: interval.end,
      end: interval.end,
      ama: `${ama}`,
      amaid: `${ama}`,
      emitent: "*",
    });
    result.push(`${aUrl}?${allParams.toString()}`);
  }
  return result;
}

function builderAnyOneIssuerNoSlices({
  aUrl,
  issues,
  slices,
  ama,
}: {
  aUrl: string;
  issues: string[];
  slices: TStringInterval[];
  ama: number;
}): string[] {
  const result = [];
  const allParams = new URLSearchParams({
    startdate: slices[0].start,
    start: slices[0].start,
    enddate: slices.at(-1).end,
    end: slices.at(-1).end,
    ama: `${ama}`,
    amaid: `${ama}`,
    emitent: "*",
  });
  result.push(`${aUrl}?${allParams.toString()}`);

  return result;
}

const builder0 = (
  aUrl: string,
  issues: string[],
  slices: TStringInterval[],
  ama: number
): string[] => {
  const result = [];
  const allParams = new URLSearchParams({
    startdate: undefined,
    start: undefined,
    enddate: undefined,
    end: undefined,
    ama: `${ama}`,
    amaid: `${ama}`,
    emitent: "*",
  });
  result.push(`${aUrl}?${allParams.toString()}`);

  return result;
};
export const epBuilderAll = curry(builder); // map through issuers and slices
/// not entirely correct. it maps on whatever issuer but if we request multiple slices theis should map over those too
export const epBuilderAnyIssuer = curry(builderAnyOneIssuer); // map through issuers and slices

export const epBuilderAnyIssuerNoSlices = curry(builder0); // one instance is enough

export function isEpBuilderAll(object: any): boolean {
  return object.urlPathBuilder === epBuilderAll;
}

export function isEpBuilderAnyIssuer(object: any): boolean {
  return object.urlPathBuilder === epBuilderAnyIssuer;
}

export function isEpBuilderAnyIssuerNoSlices(object: any): boolean {
  return object.urlPathBuilder === epBuilderAnyIssuerNoSlices;
}
